import React from 'react';
import { Sparkles } from 'lucide-react';
import { fiendishLegacyFreeSpells } from '../../../shared/rules/speciesResources.mjs';
import spellCatalog from '../../../data/spells';

/**
 * Fiendish Legacy's level 3 and 5 spells: a tile for each one's free cast (once per Long Rest, no slot). Slot casts stay
 * on the Features card, and the legacy's cantrip has an ordinary attack tile.
 */
export default function FiendishLegacySpellControls({ form, characterId, combatState, isActiveTurn, blockReason, onCast }) {
  const spells = fiendishLegacyFreeSpells(form);
  if (!spells.length) return null;
  const inCombat = Number.isInteger(combatState?.activeTurn) && Boolean(combatState?.participants?.[combatState.activeTurn]);
  const ledger = combatState?.turnActionLedger?.combatantId === String(characterId) && combatState.turnActionLedger.turnSequence === combatState.turnSequence ? combatState.turnActionLedger : null;
  const actionLeft = !ledger?.actionSpent || Boolean(ledger.actionSurge && !ledger.actionSurge.spent);
  return spells.map(({ grantId, spellId, level, remaining }) => {
    const name = spellCatalog[spellId]?.name || spellId;
    const available = remaining > 0 && !blockReason && (!inCombat || (isActiveTurn && actionLeft));
    const title = blockReason || (remaining > 0
      ? `${name} · Fiendish Legacy · Action · no spell slot, once per Long Rest`
      : `Fiendish Legacy · no free ${name} until a Long Rest (cast it with a slot from its Features card)`);
    return (
      <button key={grantId} type="button" data-action-tile={`fiendish-legacy:${grantId}`} className="combat-hud-resource-tile combat-hud-feature-action-tile" style={{ '--hud-resource-accent': '#e0726a' }}
        title={title} aria-label={`Cast ${name} free (Fiendish Legacy): ${remaining} of 1`} disabled={!available}
        onClick={() => onCast?.({ grantId, level }, { name, castingTime: spellCatalog[spellId]?.castingTime || '1 action' })}>
        <span className="combat-hud-resource-tile__icon" aria-hidden="true"><Sparkles size={20} /></span>
        <span className="combat-hud-resource-tile__name">{name}</span>
        <span className="combat-hud-resource-tile__value">{remaining}/1</span>
      </button>
    );
  });
}
